import * as React from "react";
import { Stack, Text } from "@origin-digital/ods-core";

import { Loading } from "../Loading";
import { IArticle } from "../../../../shared/interface/article";
import { routes } from "../../helpers/router.helper";
import { StyledLink } from "../../helpers/styles";

interface IProps {
  category: string;
  subcategory: string;
  articles?: IArticle[];
  loading: boolean;
  "data-id"?: string;
}

export const SubCategoryList = ({
  category,
  subcategory,
  articles,
  loading,
  "data-id": dataId = "subcategory-link",
}: IProps) => {
  const ArticleLinks = articles?.map((article, idx) => (
    <StyledLink
      data-id={`${dataId}${idx}`}
      to={routes.article(category, subcategory, article.uri)}
      key={article.title}
    >
      <Text>{article.title}</Text>
    </StyledLink>
  ));

  return (
    <Stack space="xlarge">
      {loading ? <Loading size="small" /> : ArticleLinks}
    </Stack>
  );
};
